@if (label) {
  <div class="form-field-label">{{ label }}</div>
}
<mat-form-field class="form-field form-field-currency" [floatLabel]="'auto'">
  <input
    matInput
    currencyMask
    [options]="{ align: 'left', prefix: '', thousands: '.', decimal: ',' }"
    [formControl]="control"
    [placeholder]="placeholder"
  />
  <span class="prefix">€</span>
  @if (control?.errors?.min) {
    <mat-error>
      {{ 'form.error.min' | transloco }}
    </mat-error>
  }
</mat-form-field>
